import { render, staticRenderFns } from "./Mugs.vue?vue&type=template&id=1d4d6916"
import script from "./Mugs.vue?vue&type=script&lang=js"
export * from "./Mugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports